import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";

export class SocialIconsViewModel extends BaseViewModel {
  cultureName: String;
  twitterAccount: String;
  facebookAccount: String;
  instagramAccount: String;
  youtubeAccount: String;

  constructor(cultureName: String) {
    super();
    this.cultureName = cultureName;
    this.setSocialAccountByCultureName();
  }

  setSocialAccountByCultureName(){
    switch(this.cultureName) {
      case 'pt':
        this.twitterAccount = '365Scoresbr';
        this.facebookAccount = '365Scores.Brasil';
        this.instagramAccount = '365scoresbr';
        break
      case 'pt-pt':
        this.twitterAccount = '365Scoresbr';
        this.facebookAccount = '365Scores.Brasil';
        this.instagramAccount = '365scoresbr';
        break
      case 'pt-br':
        this.twitterAccount = '365Scoresbr';
        this.facebookAccount = '365Scores.Brasil';
        this.instagramAccount = '365scoresbr';
        this.youtubeAccount = '@Basticast365';
        break;
      case 'es':
      case 'es-es':
      case 'es-419':
        this.twitterAccount = '365ScoresApp';
        this.facebookAccount = '365scores.LATAM';
        this.instagramAccount = '365scoresesp';
        break;
      case 'ar':
        this.twitterAccount = '365scoresarabic';
        this.facebookAccount = '365scores.Arabic';
        this.instagramAccount = '365scoresarabic';
        break;
      default:
        this.twitterAccount = '365Scores';
        this.facebookAccount = '365scores';
        this.instagramAccount = '365scores';
    }
  }

  get facebook() {
    return this.facebookAccount ? `https://www.facebook.com/${this.facebookAccount}` : null;
  }

  get twitter() {
    return this.twitterAccount ? `https://www.x.com/${this.twitterAccount}` : null;
  }

  get instagram() {
    return this.instagramAccount ? `https://www.instagram.com/${this.instagramAccount}` : null
  }

  get youtube() {
    return this.youtubeAccount ? `https://www.youtube.com/${this.youtubeAccount}` : null;
  }
}

